import * as ActionTypes from "../constants/actionTypes"
import { PatientSubscriptionsActionTypes } from "../constants/actionTypes"
import { IPatientData } from "../interfaces/store/patientData"
import { AppTenants } from "../constants"

function init(): IPatientData {
	return {
		patientDetails: {},
		subscriptions: [],
		allPreferredDoctors: [],
		tenant: AppTenants.SUGARFIT,
		consultations: [],
		contactNumbers: {},
	} as IPatientData
}

export const patientDataReducer = function (initialState = init(), action: any) {
	switch (action.type) {
		case ActionTypes.PatientDataActionsNames.UPDATE_PATIENT_DETAILS:
			return {
				...initialState,
				patientDetails: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_PATIENT_ACTIVE_PACK_DETAILS:
			return {
				...initialState,
				activePlan: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_USER_TENANT:
			return {
				...initialState,
				tenant: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_DOCTOR_PREFERENCE:
			return {
				...initialState,
				allPreferredDoctors: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_APPOINTMENTS_FOR_PATIENT:
			return {
				...initialState,
				consultations: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.FETCH_PATIENT_PERSONAL_PROFILE_SUCCESS:
			return {
				...initialState,
				personalProfile: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.FETCH_USER_ATTRIBUTES_SUCCESS:
			return {
				...initialState,
				userAttributes: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_USER_CONTACT_NUMBER:
			return {
				...initialState,
				contactNumbers: action.payload,
			}
		case ActionTypes.PatientDataActionsNames.UPDATE_FITNESS_LEVEL:
			return {
				...initialState,
				fitnessLevel: action.payload,
			}
		case PatientSubscriptionsActionTypes.FETCH_EXPIRED: {
			const newSubscriptions = [...(initialState.subscriptions || [])]
			newSubscriptions[0] = action.payload
			return {
				...initialState,
				subscriptions: newSubscriptions,
			}
		}
		case PatientSubscriptionsActionTypes.FETCH_ACTIVE: {
			const newSubscriptions = [...(initialState.subscriptions || [])]
			newSubscriptions[1] = action.payload
			return {
				...initialState,
				subscriptions: newSubscriptions,
			}
		}
		case PatientSubscriptionsActionTypes.FETCH_UPCOMING: {
			const newSubscriptions = [...(initialState.subscriptions || [])]
			newSubscriptions[2] = action.payload
			return {
				...initialState,
				subscriptions: newSubscriptions,
			}
		}

		case ActionTypes.PatientDataActionsNames.FETCH_LAST_COMPLETED_APPOINTMENT_FOR_PATIENT_SUCCESS: {
			return {
				...initialState,
				lastCompletedConsultation: action.payload,
			}
		}

		case ActionTypes.PatientDataActionsNames.UPDATE_USER_MANUAL_TAGS: {
			return {
				...initialState,
				userAttributes: {
					...initialState.userAttributes,
					manualTags: action.payload,
				},
			}
		}

		case ActionTypes.PatientDataActionsNames.CLEAR_PATIENT_ALL_DATA:
			return init()

		default:
			return initialState
	}
}
